<template>
  <el-dialog
    title="导入数据"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @close="closeCancelDlg"
    width="800px">
    <el-upload
      class="import-excel"
      ref="upload"
      accept=".xlsx"
      :headers="myHeader"
      :action="uploadUrl"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="false"
      :on-success="handleSuccess"
      :before-upload="beforeExcelUpload"
      :on-error="handleError"
      :on-change="changeFile">
       <el-input v-model="fileName" :disabled="true" class="import-excel-input" style="width: 560px;"></el-input>
      <el-button style="margin-left: 72px;"  type="primary" icon="el-icon-upload2" :loading="loading" >选取文件</el-button>
    </el-upload>
    <div class="line"></div>
    <el-row>
      <el-col :span="8">
        <el-button  @click="visible = false" :loading="loading"  style="width: 88px;">取消</el-button>
        <el-button  type="primary" @click="submitUpload" :loading="loading"  style="margin-left: 10px;width: 88px;" >导入</el-button>
      </el-col>
    </el-row>
  </el-dialog>

</template>

<script>
export default {
  name: 'offering-batch-up',
  data () {
    let _this = this
    return {
      loading: false,
      visible: false,
      errorList: [],
      fileName: '',
      myHeader:{
        token:this.getStorage(this.GLOBAL.TOKEN)
      },
      uploadUrl: '',
      url: '/learning/base/offeringinfo/importOfferingBatch',
      hasError: false,
      courseTeamCatalogSecond:'',
      projectCourseFlag:'',
      allteamcatalog: _this.enums['catalogidList2']
    }
  },
  created () {
    this.getTeamRole()
    this.getprojectCourseFlagRole ()
    this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `?courseTeamCatalogSecond=${this.courseTeamCatalogSecond}`+ `&projectCourseFlag=${this.projectCourseFlag}`
    console.log("this.uploadUrl")
    console.log(this.uploadUrl)
    this.num = 0
    this.fileList = []
    this.visible = true
  },
  methods: {
    indexMethod (index) {
      return index + 1
    },
    getTeamRole () {
      let tempArry = []
      for (var val of this.allteamcatalog) {
        if (this.$hasPermission('TEAM:'+val.code)) {
          tempArry.push(val.code)
        }
      }
      if (tempArry.length > 0) {
        this.courseTeamCatalogSecond = tempArry.join(',')
      }
    },
    getprojectCourseFlagRole () {
      if (this.$hasPermission('learning:offering:trainerOffering')) {
        this.projectCourseFlag = '10'
      }
    },

    beforeExcelUpload (file) {
      console.log(file)
      let maxLength = 2 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '大小不能超过2M',
          type: 'error',
          duration: 1500,
          onClose: () => {
          }
        })
        this.init()
        this.loading = false
        return false
      }
      let fileName = file.name
      let first = fileName.lastIndexOf('.')// 取到文件名开始到最后一个点的长度
      let namelength = fileName.length // 取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength)// 截取获得后缀名
      if (filesuffix !== 'xlsx') {
        this.$message({
          message: '只能上传Excel',
          type: 'error',
          duration: 1500,
          onClose: () => {
            // this.$emit('refreshDataList')
          }
        })
        this.init()
        this.loading = false
        return false
      }
      // 校验文件格式
      if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.$message({
          message: '只能上传Excel',
          type: 'error',
          duration: 1500,
          onClose: () => {
          }
        })
        this.init()
        this.loading = false
        return false
      }
      return true
    },
    init () {
      console.log('1111111')
      this.visible = true
      this.fileName = ''
      this.loading = false
      console.log(this.loading)
    },
    submitUpload () {
      if (this.fileName) {
        console.log('submitUpload')
        this.loading = true
        this.$refs.upload.submit()
      }
    },
    changeFile (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName = file.name
      }
    },
    handleSuccess (response, file, fileList) {
      console.log(response)
      if (response.code !== '2' && response.data !== null && response.data.length > 0) {
        this.errorList = response.data
        this.hasError = true
        this.init()
        return
      }
      if (Number(response.code) < 0) {
        this.$message({
          message: response.msg,
          type: 'error',
          duration: 1500,
          onClose: () => {
            console.log('close')
          }
        })
        this.init()
        this.loading = false
        return 0
      }
      if (Number(response.code) === 10002) {
        this.$message({
          message: '请使用正确模板',
          type: 'error',
          duration: 1500,
        })
        this.init()
        this.loading = false
        return 0
      }
      if (Number(response.code) === 10003) {
        this.$message({
          message: '当前数据不能为空',
          type: 'error',
          duration: 1500,
          onClose: () => {
            console.log('close')
          }
        })
        this.init()
        this.loading = false
        return 0
      }
      this.$message({
        message: '请点击“上传结果”查看结果报告',
        type: 'success',
        duration: 4500
      })
      this.init()
      this.$emit('filenamelist', response.data)
      this.visible = false
    },
    handleError (err, file, fileList) {
      console.log(err + file + fileList)
      this.loading = false
    },
    // 导出
    exportHandle () {
      // download 参数 url, params, 报表名
      this.$request.downloadLearning(this.shuttering, this.name)
    },
    // 取消
    closeCancelDlg(){
      this.$emit('closeCancelDlg')
    }
  }
}
</script>
<style lang='scss' scoped>
  .import-excel .el-upload.el-upload--text {
    float: right;
    margin-right: 37px;
  }
  .import-excel {
    height: 60px;
  }
  .import-excel .import-excel-input .el-input__inner{
    color: black;
  }
</style>
<style lang='scss' scoped>
  .line {
    height: 1px;
    border-top: 1px solid #b2b0b4;
    text-align: center;
    margin: 10px;
  }
</style>
